<template>
  <div class="user-container">
    <div class="table-field-list">
      <el-row>
        <el-col :span="6">
          <label>图片类别:</label>
          <el-select v-model="params.type" placeholder="请选择">
            <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <label>状态:</label>
          <el-select v-model="params.status" placeholder="请选择">
            <el-option
              v-for="(item,index) in statusList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="1">
          <el-button type="primary" @click="handleSearch">搜索</el-button>
        </el-col>
        <el-col :span="2">
          <el-button type="success" @click="dialogFormVisible = true">新增</el-button>
        </el-col>
      </el-row>
    </div>
    <el-table
      :data="tableData"
      :row-style="{height:'30px'}"
      :cell-style="{padding:'5px 0',textAlign: `center`}"
      style="width: 100%;margin-top:30px;"
      height="580px"
      :border="true"
      :header-cell-style="{background: '#f2f2f2'}"
    >
      <el-table-column prop="orderSort" label="排序" width="50"></el-table-column>
      <el-table-column prop="type" label="类别">
        <template slot-scope="scope">
          <span>{{ typeList.find(item=> item.id === scope.row.type).name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === `1`" type="danger">未启用</el-tag>
          <el-tag v-if="scope.row.status === `2`" type="success">已启用</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="userName" label="新增人"></el-table-column>
      <el-table-column prop="createDate" label="创建时间"></el-table-column>
      <el-table-column prop="updateDate" label="更新时间"></el-table-column>
      <el-table-column prop="imgUrl" label="图片预览">
        <template slot-scope="scope">
          <el-image style="width: 100px; height: 100px" :src="scope.row.imgUrl" :fit="`fill`"></el-image>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="300">
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            icon="el-icon-caret-right"
            v-if="scope.row.status === `1`"
            @click="handleUpdateImage(scope.row.id,`2`)"
          >启用</el-button>
          <el-button
            type="warning"
            size="mini"
            icon="el-icon-video-pause"
            v-if="scope.row.status !== `1`"
            @click="handleUpdateImage(scope.row.id,`1`)"
          >禁用</el-button>
          <el-button
            type="danger"
            icon="el-icon-edit"
            size="mini"
            @click="handleDeleteImage(scope.row.id)"
          >删除</el-button>
          <el-button
            type="primary"
            icon="el-icon-edit"
            size="mini"
            @click="sortDTO.id = scope.row.id;isUpdateSort=true"
          >设置序号</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :page-size="params.limit"
      :current-page="params.page"
      style="margin-top:30px;"
      background
      layout="total,prev, pager, next"
      :total="total"
      @current-change="handleClickPage"
    ></el-pagination>
    <el-dialog :title="`新增图片`" :width="`450px`" :visible.sync="dialogFormVisible">
      <el-form :model="addDTO">
        <el-form-item label="图片类别">
          <el-select v-model="addDTO.type" placeholder="请选择">
            <el-option
              v-for="item in typeAddList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="图片上传" v-show="addDTO.type - 2 === 0">
          <el-upload
            action="/admin/file/upload/image/size"
            :headers="token"
            :on-success="iconUpload"
            multiple
            drag
            :limit="fileLimit"
            list-type="picture"
            :file-list="iconList"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或
              <em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              只能上传jpg/png文件，且大小不超过2MB
              <br />
              <span v-show="addDTO.type - 2 === 0">像素大小450px*340px显示最佳</span>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item v-show="addDTO.type===`1`" label="图片上传">
          <el-upload
            action="/admin/file/upload/image"
            :headers="token"
            :on-success="iconUpload"
            multiple
            drag
            :limit="fileLimit"
            list-type="picture"
            :file-list="iconList"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或
              <em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且大小不超过2MB</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAddImage">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="`设置序号`" :width="`450px`" :visible.sync="isUpdateSort">
      <el-form :model="addDTO">
        <el-form-item label="序号">
          <el-input
            style="width:300px;"
            v-model="sortDTO.sort"
            autocomplete="off"
            placeholder="请输入排序序号"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isUpdateSort = false">取 消</el-button>
        <el-button type="primary" @click="handleUploadImageLimit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QS from "qs";
import {
  imageList,
  addImage,
  deleteImage,
  updateImage,
  uploadImageLimit
} from "@/axios/api";
export default {
  data() {
    return {
      tableData: [],
      total: 0,
      dialogFormVisible: false,
      token: {
        access_token: ""
      },
      params: {
        page: 1,
        limit: 30,
        type: "1",
        status: ""
      },
      statusList: [
        {
          id: "",
          name: "全部"
        },
        {
          id: "1",
          name: "未启用"
        },
        {
          id: "2",
          name: "启用"
        }
      ],
      typeList: [
        {
          id: "1",
          name: "历届荣誉"
        },
        {
          id: "2",
          name: "企业文化"
        }
      ],
      typeAddList: [
        {
          id: "1",
          name: "历届荣誉"
        },
        {
          id: "2",
          name: "企业文化"
        }
      ],
      addDTO: {
        type: "1",
        imgUrl: ""
      },
      fileLimit: 1,
      iconList: [],
      sortDTO: {
        id: "",
        sort: ""
      },
      isUpdateSort: false
    };
  },
  methods: {
    handleUploadImageLimit() {
      uploadImageLimit(this.sortDTO).then(res => {
        if (res.status === 200) {
          this.$message.success("设置成功");
          this.handlePageData();
          this.isUpdateSort = false;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleUpdateImage(id, status) {
      updateImage({ id: id, status: status }).then(res => {
        if (res.status === 200) {
          this.$message.success("删除成功");
          this.params.page = 1;
          this.handlePageData();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleDeleteImage(id) {
      deleteImage({ id: id }).then(res => {
        if (res.status === 200) {
          this.$message.success("删除成功");
          this.params.page = 1;
          this.handlePageData();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleClickPage(event) {
      this.params.page = event;
      this.handlePageData();
    },
    handleAddImage() {
      addImage(this.addDTO).then(res => {
        if (res.status === 200) {
          this.$message.success("新增成功");
          this.iconList = [];
          this.dialogFormVisible = false;
          this.handlePageData();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleSearch() {
      this.params.page = 1;
      this.handlePageData();
    },
    handlePageData() {
      imageList(this.params).then(res => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
    iconUpload(res) {
      if (res.status === 200) {
        this.$message.success("上传成功");
        this.addDTO.imgUrl = res.data;
      } else {
        this.iconList = [];
        this.$message.error(res.msg);
      }
    }
  },
  mounted() {
    this.handlePageData();
    let user = QS.parse(localStorage.getItem("admin"));
    this.token.access_token = user.token;
  }
};
</script>

<style scoped>
.table-field-list .el-row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.table-field-list {
  width: 100%;
  height: 100px;
  border: 1px solid #ebebeb;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 50px;
  box-sizing: border-box;
  padding: 30px;
}
.user-container {
  width: 100%;
  height: auto;
  position: relative;
}
</style>


// WEBPACK FOOTER //
// src/views/image/Index.vue